import { useCallback } from 'react';
import classnames from 'classnames';
import Grid, { IGridProps } from '../Grid';
import {
  AB1, AB3, S1, S2, S3,
} from '../../theme';
import { mergeSX } from '../../services/helpers';

interface IBuildSXParams {
  hideBorder: boolean;
}

const buildSX = ({ hideBorder }: IBuildSXParams) => ({
  borderRadius: '16px',
  backgroundColor: S1,
  border: hideBorder ? 'none' : `2px solid ${S3}`,
  '&:hover': {
    backgroundColor: AB1,
    cursor: 'pointer',
    border: hideBorder ? 'none' : '2px solid transparent',
  },
  '&.selected': {
    backgroundColor: S2,
    border: hideBorder ? 'none' : `2px solid ${AB3}`,
    '&:hover': {
      backgroundColor: AB1,
    },
  },
  '&.disabled': {
    backgroundColor: S3,
    cursor: 'not-allowed',
    '&:hover': {
      backgroundColor: S3,
    },
  },
});

export interface IClickableContainerProps extends IGridProps {
  hideBorder?: boolean;
  selected?: boolean;
  disabled?: boolean;
  value?: any;
}

const ClickableContainer = (props: IClickableContainerProps) => {
  const {
    children,
    sx,
    className,
    value,
    hideBorder = false,
    selected = false,
    disabled = false,
    onClick,
    ...rest
  } = props;

  const handleClick = useCallback(() => {
    if (!onClick || disabled) return;
    onClick(value);
  }, [value, disabled, onClick]);

  return (
    <Grid
      p={2}
      pr={4}
      className={classnames(className, {
        selected,
        disabled,
      })}
      sx={mergeSX(buildSX({ hideBorder }), sx)}
      onClick={handleClick}
      {...rest}
    >
      {children}
    </Grid>
  );
};

export default ClickableContainer;
